/* app/js/src/components/common/hourPicker/hour-picker.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.container {
  position: relative;
}
.container .input {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 158px;
  height: 30px;
  border-radius: 4px;
  background-color: #ffffff;
  border: solid 1px #e1e6eb;
  line-height: 30px;
  padding-left: 10px;
  font-size: 12px;
  color: #232f3a;
  cursor: pointer;
}
.container .input.active {
  border: 1px solid #aee5ff;
}
.container .input div {
  display: inline-block;
  position: absolute;
  right: 0;
  margin: 7px 8px 7px 0;
}
.container .input div.active ::ng-deep svg path {
  fill: #40c4ff !important;
}
.container .picker {
  width: 215px;
  height: 195px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #e1e6eb;
  z-index: 10;
  margin-top: 5px;
  position: absolute;
  top: -210px;
  right: 0;
}
.container .picker .header {
  width: 100%;
  height: 35px;
  background-color: #eef2f6;
  font-size: 12px;
  color: #7d8fa1;
  text-align: center;
  line-height: 35px;
}
.container .picker .content {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 126px;
  align-items: center;
}
.container .picker .content .hourcell {
  width: 30px;
  height: 26px;
  text-align: center;
  line-height: 26px;
  margin: 0 2px 0 2px;
  cursor: pointer;
  font-size: 16px;
}
.container .picker .content .hourcell.chosen {
  background-color: #232f3a;
  color: #ffffff;
}
.container .picker .hourcell:hover {
  background-color: #eef2f6;
}
.container .picker .apply-btn {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 60px;
  height: 28px;
  border-radius: 4px;
  font-size: 12px;
  color: #ffffff;
  background-color: #232f3a;
  cursor: pointer;
  position: absolute;
  right: 7px;
  bottom: 0;
  margin: 0 5px 5px 0;
  text-align: center;
  line-height: 28px;
}
.container .picker .apply-btn:hover {
  background-color: #40c4ff;
}
.close-calendar {
  cursor: pointer;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  position: absolute;
  right: -12px;
  top: -15px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  background: #ffffff url(/assets/icons/x-close-pop.svg) no-repeat center;
  z-index: 1;
}
/*# sourceMappingURL=hour-picker.component.css.map */
